import React, { Component } from "react";
import { connect } from "react-redux";
import { FormGroup, ControlLabel } from "react-bootstrap";
import Datetime from "react-datetime";
import "./index.css";
import "../../react_datetime.css";
import FontAwesome from "react-fontawesome";

class DateTimePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultDate: "",
      selectedDate: this.props.defaultValue ? new Date(this.props.defaultValue) : undefined,
      timeFormat: this.props.disableTime ? false : "hh:mm A",
      dateTimeText: this.props.disableTime ? "" : " (Date | Time)",
      isValidDate: this.props.isValidDate || function() { return true; }
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.reset !== nextProps.reset) {
      this.setState({
        selectedDate: ""
      });
      this.props.changeDate("");
    }

    if (this.props.isValidDate !== nextProps.isValidDate) {
      this.setState({ isValidDate: this.props.isValidDate });
    }
  }

  renderInput = (props) => {
    function clear() {
      props.onChange({ target: { value: "" } });
    }
    return (
      <div>
        <input {...props} />
        {this.state.selectedDate ? <a className="btn-clear" onClick={clear}><FontAwesome name="times" /></a> : null}
      </div>
    );
  }

  handleDateChange = e => {
    this.setState(() => {
      return {
        selectedDate: e._d ? e._d : ""
      };
    });
    this.props.changeDate(e);
  };

  render = () => {
    const { defaultDate, selectedDate, timeFormat, dateTimeText, isValidDate } = this.state;
    return (
      <div className="date-time">
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>{this.props.timePeriod} {dateTimeText}</ControlLabel>
          <Datetime
            dateFormat="DD-MM-YYYY"
            timeFormat={timeFormat}
            onChange={this.handleDateChange}
            defaultValue={defaultDate}
            value={selectedDate}
            renderInput={this.renderInput}
            isValidDate={isValidDate}
          />
        </FormGroup>
      </div>
    );
  };
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user
  };
}

export default connect(mapStateToProps)(DateTimePicker);



// WEBPACK FOOTER //
// ./src/_components/DateTimePicker/index.js